import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CLIENT_FIELDS = [
  ["ragione_sociale", "Ragione sociale"], ["sede_legale", "Sede legale (indirizzo completo)"],
  ["piva", "Partita IVA"], ["codice_fiscale", "Codice fiscale"],
  ["legale_rappresentante", "Legale rappresentante"], ["pec", "PEC"],
  ["sdi", "Codice SDI"], ["email", "Email"], ["telefono", "Telefono"],
];

const Field = ({ k, label, data, set, type = "text" }) => (
  <div>
    <Label className="text-xs font-bold text-navy">{label}</Label>
    <Input type={type} value={data[k] ?? ""} data-testid={`contract-${k}-input`} className="mt-1.5"
      onChange={(e) => set({ ...data, [k]: type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value })} />
  </div>
);

export default function ContractForm({ data, set }) {
  const onPay = (v) => set({ ...data, pagamento_tipo: v, sconto_pagamento_percent: v === "annuale" ? (data.sconto_pagamento_percent || 10) : 0 });
  return (
    <div className="space-y-8">
      <section>
        <h3 className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-4">Dati cliente</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          {CLIENT_FIELDS.map(([k, l]) => <Field key={k} k={k} label={l} data={data} set={set} />)}
        </div>
      </section>
      <section>
        <h3 className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-4">Durata e firma</h3>
        <div className="grid sm:grid-cols-3 gap-4">
          <Field k="luogo" label="Luogo firma" data={data} set={set} />
          <Field k="data_sottoscrizione" label="Data sottoscrizione" type="date" data={data} set={set} />
          <Field k="data_decorrenza" label="Data decorrenza" type="date" data={data} set={set} />
          <Field k="durata_mesi" label="Durata (mesi)" type="number" data={data} set={set} />
          <Field k="preavviso_mesi" label="Preavviso disdetta (mesi)" type="number" data={data} set={set} />
        </div>
      </section>
      <section>
        <h3 className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-4">Pagamento e sconti</h3>
        <div className="grid sm:grid-cols-3 gap-4">
          <div>
            <Label className="text-xs font-bold text-navy">Termini di pagamento</Label>
            <Select value={data.pagamento_tipo} onValueChange={onPay}>
              <SelectTrigger className="mt-1.5" data-testid="contract-pagamento-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="annuale">Annuale anticipato (unica soluzione)</SelectItem>
                <SelectItem value="semestrale">Semestrale anticipato</SelectItem>
                <SelectItem value="trimestrale">Trimestrale anticipato</SelectItem>
                <SelectItem value="mensile">Mensile anticipato</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Field k="sconto_pagamento_percent" label="Sconto per pagamento (%)" type="number" data={data} set={set} />
          <Field k="sconto_durata_mesi" label="Durata sconti (mesi, 0 = sempre)" type="number" data={data} set={set} />
        </div>
        <div className="grid sm:grid-cols-2 gap-4 mt-4">
          <div>
            <Label className="text-xs font-bold text-navy">Note pagamento (opzionale)</Label>
            <Textarea value={data.pagamento_note} data-testid="contract-pagamento-note" className="mt-1.5" rows={2}
              onChange={(e) => set({ ...data, pagamento_note: e.target.value })} />
          </div>
          <div>
            <Label className="text-xs font-bold text-navy">Note sconti (opzionale)</Label>
            <Textarea value={data.sconti_note} data-testid="contract-sconti-note" className="mt-1.5" rows={2}
              onChange={(e) => set({ ...data, sconti_note: e.target.value })} />
          </div>
        </div>
        <p className="text-xs text-muted-foreground mt-3">Moduli, marketplace, integrazioni, prezzi e sconti dell'offerta vengono inseriti automaticamente nel contratto.</p>
      </section>
    </div>
  );
}
